
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/articles/importance-of-machine-data-collection",
      function () {
        return require("private-next-pages/[locale]/articles/importance-of-machine-data-collection.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/articles/importance-of-machine-data-collection"])
      });
    }
  